import { isExternalImageUrl } from '../utils/productImages';

export async function mirrorExternalImage(
  url: string,
  folder = 'products'
): Promise<string> {
  if (!url || !isExternalImageUrl(url)) {
    return url;
  }

  try {
    const response = await fetch('/api/images/mirror', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url, folder }),
    });

    if (!response.ok) {
      console.warn(`Failed to mirror image (${response.status}): ${url}`);
      return url;
    }

    const data = await response.json();
    return data.file_url || url;
  } catch (err) {
    console.warn('Failed to mirror external image:', err);
    return url;
  }
}

export async function mirrorExternalImages(
  urls: string[],
  folder = 'products'
): Promise<string[]> {
  return Promise.all(urls.map((url) => mirrorExternalImage(url, folder)));
}
